/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressReleaseCity,
    PressReleaseCityFromJSON,
    PressReleaseCityFromJSONTyped,
    PressReleaseCityToJSON,
} from './PressReleaseCity';

/**
 * プレスリリース位置情報(市町村)マスター
 * @export
 * @interface PressReleaseCityMaster
 */
export interface PressReleaseCityMaster {
    /**
     * 
     * @type {Array<PressReleaseCity>}
     * @memberof PressReleaseCityMaster
     */
    cities: Array<PressReleaseCity>;
}

export function PressReleaseCityMasterFromJSON(json: any): PressReleaseCityMaster {
    return PressReleaseCityMasterFromJSONTyped(json, false);
}

export function PressReleaseCityMasterFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressReleaseCityMaster {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cities': ((json['cities'] as Array<any>).map(PressReleaseCityFromJSON)),
    };
}

export function PressReleaseCityMasterToJSON(value?: PressReleaseCityMaster | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cities': ((value.cities as Array<any>).map(PressReleaseCityToJSON)),
    };
}

